import { ProductType } from '@tink/core/src/types';
import { TinkLinkUrlParameter } from '@tink/config/src/TinkLinkUrlParameter';
import { RefreshableItem } from '../../models/refreshableItem';
import { validateExternalReference, ValidateProductParams } from '../../utilities/urlParameters';
import { getValidRefreshableItems } from '../../utilities/validators';

export const defaultAccountCheckRefreshableItems = [
  RefreshableItem.CHECKING_ACCOUNTS,
  RefreshableItem.SAVING_ACCOUNTS,
  RefreshableItem.IDENTITY_DATA,
];

export const validateParams: ValidateProductParams = ({ externalReference }, getRawParam) => {
  const queryRefreshableItems = getValidRefreshableItems(
    getRawParam(TinkLinkUrlParameter.REFRESHABLE_ITEMS)
  );

  const errors = [];

  const externalReferenceError = validateExternalReference(externalReference || '');

  if (externalReferenceError) {
    errors.push(externalReferenceError);
  }

  return {
    parameters: {
      productType: ProductType.ACCOUNT_CHECK,
      refreshableItems:
        queryRefreshableItems.length > 0
          ? queryRefreshableItems
          : defaultAccountCheckRefreshableItems,
    },
    errors,
  };
};
